import React from 'react';

const actionsColumnWidth = { width: '8rem' };

export const ActionsColumnHeader = () => <th style={actionsColumnWidth}></th>;
